"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var effects_1 = require("redux-saga/effects");
var invoiceState_1 = require("../states/invoiceState");
var invoiceService_1 = require("../services/invoiceService");
var authSelectors_1 = require("../selectors/authSelectors");
var settingsSelectors_1 = require("../selectors/settingsSelectors");
var i18n_1 = __importDefault(require("../i18n"));
var reportErrorsToInstrumentation_1 = __importStar(require("../helper/reportErrorsToInstrumentation"));
var productInvoice_1 = __importDefault(require("../models/productInvoice"));
var authState_1 = require("../states/authState");
var utils_1 = require("../helper/utils");
var invoiceDocument_1 = __importDefault(require("../models/invoiceDocument"));
var invoice_1 = __importDefault(require("../models/invoice"));
function fetchLastBill(action) {
    var token, data, e_1, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 11]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(invoiceService_1.fetchLastBillByCustomerAccountIdService, action.payload, token)];
            case 2:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.fetchLastBillSuccess(data))];
            case 3:
                _a.sent();
                return [3 /*break*/, 11];
            case 4:
                e_1 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_1)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.fetchLastBillFailure(errorMsg))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_1, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchLastBill.name))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function fetchBillsList(action) {
    var token, data, e_2, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 11]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(invoiceService_1.fetchBillsListByCustomerAccountIdService, action.payload, token)];
            case 2:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.fetchBillsListSuccess(data))];
            case 3:
                _a.sent();
                return [3 /*break*/, 11];
            case 4:
                e_2 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_2)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.fetchBillsListFailure(errorMsg))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_2, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchBillsList.name))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function fetchLastInvoiceEffect(action) {
    var token, data, e_3, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 10]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(invoiceService_1.fetchLastInvoiceService, action.payload, token)];
            case 2:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.fetchLastInvoiceSuccess(data))];
            case 3:
                _a.sent();
                return [3 /*break*/, 10];
            case 4:
                e_3 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_3)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: 
            //removed the else we always put the fetch in error
            return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.fetchLastInvoiceFailure(errorMsg))];
            case 8:
                //removed the else we always put the fetch in error
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_3, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchLastInvoiceEffect.name))];
            case 9:
                _a.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function fetchAllInvoiceEffect(action) {
    var token, data, productInvoices, e_4, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 7, , 16]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(invoiceService_1.fetchAllInvoiceService, action.payload, token)];
            case 2:
                data = _a.sent();
                if (!data) return [3 /*break*/, 4];
                productInvoices = data.map(function (el) { return new productInvoice_1.default(el); });
                return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.fetchAllInvoicesSuccess(productInvoices))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.fetchAllInvoicesSuccess([]))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 16];
            case 7:
                e_4 = _a.sent();
                if (!(e_4["response"] && e_4["response"]["status"] === 404)) return [3 /*break*/, 9];
                return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.fetchAllInvoicesSuccess([]))];
            case 8:
                _a.sent();
                return [3 /*break*/, 14];
            case 9: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 10:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_4)) return [3 /*break*/, 12];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 11:
                _a.sent();
                _a.label = 12;
            case 12: 
            //removed the else put the fetch invoices to error anyway
            return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.fetchAllInvoicesFailure(errorMsg))];
            case 13:
                //removed the else put the fetch invoices to error anyway
                _a.sent();
                _a.label = 14;
            case 14: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_4, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchAllInvoiceEffect.name))];
            case 15:
                _a.sent();
                return [3 /*break*/, 16];
            case 16: return [2 /*return*/];
        }
    });
}
function getAllInvoicesEffect(action) {
    var token, data, invoices, e_5, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 7, , 16]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(invoiceService_1.getAllInvoicesService, action.payload, token)];
            case 2:
                data = _a.sent();
                if (!data) return [3 /*break*/, 4];
                invoices = data.map(function (el) { return new invoice_1.default(el); });
                return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.getAllInvoicesSuccess(invoices))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.getAllInvoicesSuccess([]))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 16];
            case 7:
                e_5 = _a.sent();
                if (!(e_5["response"] && e_5["response"]["status"] === 404)) return [3 /*break*/, 9];
                return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.getAllInvoicesSuccess([]))];
            case 8:
                _a.sent();
                return [3 /*break*/, 14];
            case 9: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 10:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_5)) return [3 /*break*/, 12];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 11:
                _a.sent();
                _a.label = 12;
            case 12: return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.getAllInvoicesFailure(errorMsg))];
            case 13:
                _a.sent();
                _a.label = 14;
            case 14: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_5, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, getAllInvoicesEffect.name))];
            case 15:
                _a.sent();
                return [3 /*break*/, 16];
            case 16: return [2 /*return*/];
        }
    });
}
function handleDownloadInvoiceDocumentsFailure(e) {
    var language, errorMsg, status, data, _a;
    var _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_f.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                status = (_c = (_b = e === null || e === void 0 ? void 0 : e.response) === null || _b === void 0 ? void 0 : _b.status) !== null && _c !== void 0 ? _c : null;
                data = (_e = (_d = e === null || e === void 0 ? void 0 : e.response) === null || _d === void 0 ? void 0 : _d.data) !== null && _e !== void 0 ? _e : null;
                _a = true;
                switch (_a) {
                    case [500, 503, 504].includes(status): return [3 /*break*/, 2];
                    case status === 404 && data === 'DocumentNotFound': return [3 /*break*/, 3];
                    case status === 415 && data === 'DocumentExtensionNotSupported': return [3 /*break*/, 4];
                    case (0, utils_1.unauthorizedError)(e): return [3 /*break*/, 5];
                }
                return [3 /*break*/, 7];
            case 2:
                errorMsg = (0, i18n_1.default)(language).common.serviceUnavailable;
                return [3 /*break*/, 7];
            case 3:
                errorMsg = (0, i18n_1.default)(language).invoice.errorApi.documentNotFound;
                return [3 /*break*/, 7];
            case 4:
                errorMsg = (0, i18n_1.default)(language).invoice.errorApi.documentExtensionNotSupported;
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 6:
                _f.sent();
                return [3 /*break*/, 7];
            case 7: return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.downloadInvoiceDocumentsFailure(errorMsg, status, data))];
            case 8:
                _f.sent();
                return [2 /*return*/];
        }
    });
}
function downloadInvoiceDocumentsEffect(action) {
    var token, response, data, e_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 7]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(invoiceService_1.downloadInvoiceDocumentsService, action.payload, token)];
            case 2:
                response = _a.sent();
                data = new invoiceDocument_1.default(response.data);
                return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.downloadInvoiceDocumentsSuccess(data))];
            case 3:
                _a.sent();
                return [3 /*break*/, 7];
            case 4:
                e_6 = _a.sent();
                return [4 /*yield*/, handleDownloadInvoiceDocumentsFailure(e_6)];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_6, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, downloadInvoiceDocumentsEffect.name))];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function downloadInvoiceDocumentsForPreviewEffect(action) {
    var token, response, data, e_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 7]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(invoiceService_1.downloadInvoiceDocumentsService, action.payload, token)];
            case 2:
                response = _a.sent();
                data = new invoiceDocument_1.default(response.data);
                return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.downloadInvoiceDocumentsSuccessForPreview(data))];
            case 3:
                _a.sent();
                return [3 /*break*/, 7];
            case 4:
                e_7 = _a.sent();
                return [4 /*yield*/, handleDownloadInvoiceDocumentsFailure(e_7)];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_7, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, downloadInvoiceDocumentsForPreviewEffect.name))];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function invoicesEffects() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(invoiceState_1.invoiceActions.fetchLastInvoice.type, fetchLastInvoiceEffect)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(invoiceState_1.invoiceActions.fetchAllInvoices.type, fetchAllInvoiceEffect)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(invoiceState_1.invoiceActions.getAllInvoices.type, getAllInvoicesEffect)];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(invoiceState_1.invoiceActions.downloadInvoiceDocuments.type, downloadInvoiceDocumentsEffect)];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(invoiceState_1.invoiceActions.downloadInvoiceDocumentsForPreview.type, downloadInvoiceDocumentsForPreviewEffect)];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(invoiceState_1.invoiceActions.fetchLastBill.type, fetchLastBill)];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(invoiceState_1.invoiceActions.fetchBillsList.type, fetchBillsList)];
            case 7:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.default = invoicesEffects;
